import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllemployeeReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/employeereport');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Employee Report');
        }
    }
);


export const fetchAllemployeeNumberBymonth = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/employeereport/employeenumber/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Employee number');
        }
    }
);